import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_EXTERNAL_PEOPLE,
  PATH_EXTERNAL_PEOPLE_NEW,
  PATH_EXTERNAL_THIRD_PARTIES_DEFAULT,
} from '../../app/constants/paths.constant';
import { FormVariant } from '../../forms';
import { PersonForm } from '../../forms/ThirdParty/Person';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const NewExternalPersonPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.ExternalThirdParties);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle("Création d'une Personne")}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_EXTERNAL_THIRD_PARTIES_DEFAULT,
            label: 'tiers',
            key: 'externalThirdParties',
          },
          {
            to: PATH_EXTERNAL_PEOPLE,
            label: 'personnes',
            key: 'externalPeople',
          },
          {
            to: PATH_EXTERNAL_PEOPLE_NEW,
            label: 'nouvelle',
            key: 'externalNewPerson',
          },
        ]}
      />
      <PageTitle title="Création d'une Personne" />
      <PersonForm
        formVariant={FormVariant.Creation}
        isInternal={false}
        showCancelButton={false}
      />
    </>
  );
};
